/** The supplied Magicweave mark: black in Light, white in Dark, with its green highlight. */
export function Logo({ className }: { className?: string }) {
  return (
    <span className={`relative inline-block ${className ?? ""}`} aria-hidden="true">
      <img
        src="/brand/mark-light.png"
        alt=""
        className="absolute inset-0 size-full object-contain"
        style={{ opacity: "var(--brand-mark-light-opacity)" }}
      />
      <img
        src="/brand/mark-dark.svg"
        alt=""
        className="absolute inset-0 size-full object-contain"
        style={{ opacity: "var(--brand-mark-dark-opacity)" }}
      />
    </span>
  );
}
